<template>
  <div class="performanceBox" v-loading="loading" :element-loading-text="loadingStr">
    <div class="performanceMain" v-if="!loading">
      <breadcrumb>
        <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/personal/sign/home' }">签约管理</el-breadcrumb-item>

          <el-breadcrumb-item v-if="$route.query.flag=='startSign'&&isSuccess===true">签约创建成功</el-breadcrumb-item>
          <el-breadcrumb-item v-if="$route.query.flag=='startSign'&&isSuccess===false">签约创建失败</el-breadcrumb-item>
          <el-breadcrumb-item
            v-if="$route.query.flag=='sign'&&isSuccess==true&&detail&&detail.info&&detail.info.signStatus == 1"
          >签约成功</el-breadcrumb-item>
          <el-breadcrumb-item
            v-if="$route.query.flag=='sign'&&isSuccess==false&&detail&&detail.info&&detail.info.signStatus == 1"
          >签约失败</el-breadcrumb-item>
          <el-breadcrumb-item
            v-if="$route.query.flag=='sign'&&detail&&detail.info&&detail.info.signStatus == 2"
          >签署已完成</el-breadcrumb-item>
        </el-breadcrumb>
      </breadcrumb>
      <div class="signDetailMenu" v-if="detail">
        <ul>
          <li @click="toSign" v-if="contractUserIsFirst">
            <img class="hover" src="@image/personalSignDetail/signing_icon_hov_pre.png">
            <img class="normal" src="@image/personalSignDetail/signing_icon_nor.png">
            去签署
          </li>
          <li @click="selectContract">
            <img class="hover" src="@image/personalSignDetail/Circlereach_icon_hov.png">
            <img class="normal" src="@image/personalSignDetail/Circlereach_icon_nor.png">
            查看合同
          </li>
          <li v-if="detail&&detail.info&&detail.info.signStatus == 2" @click="selectCre">
            <img class="hover" src="@image/personalSignDetail/bigFaceHov.png">
            <img class="normal" src="@image/personalSignDetail/bigFaceNor.png">
            查看证书
          </li>
          <li v-if="detail && detail.info && ((detail.info.type == 2 && detail.info.signStatus == 2 && getUserInfo && getUserInfo.currentUserId != detail.contractUser.userId) || (detail.info.type == 4 && detail.info.mySignStatus == 2 && this.detail.info.signatoryRoleCode == 'DR'))" @click="addNotrats()">
            <img class="normal" src="@image/personalSignDetail/addHov.png">
            <img class="hover" src="@image/personalSignDetail/addNor.png">
            申请公证
          </li>
          <!-- <li v-if="detail&&detail.info&&detail.info.signStatus == 2" @click="addFn(1)">
            <img class="hover" src="@image/personalSignDetail/sifaHov.png">
            <img class="normal" src="@image/personalSignDetail/sifaNor.png">
            司法鉴定
          </li> -->
          <!-- <li v-if="detail&&detail.info&&detail.info.signStatus == 2" @click="addFn(0)">
            <img class="normal" src="@image/personalSignDetail/addHov.png">
            <img class="hover" src="@image/personalSignDetail/addNor.png">申请律师服务
          </li> -->
          <li v-if="judgeRevoke()" @click="showReject">
            <img class="hover" src="@image/personalSignDetail/returnNor.png">
            <img class="normal" src="@image/personalSignDetail/returnHover.png">撤销合同
          </li>
        </ul>
      </div>
      <div class="performanceConFinsh">
        <div class="performancebody">
          <img
            src="../../../assets/images/register/success_icon.png"
            v-if="isSuccess===true&&blockDetail.txId"
            alt
          >
          <img
            src="../../../assets/images/register/fail_icon.png"
            v-if="isSuccess === false||!blockDetail.txId"
            alt
          >
          <p
            class="ft16"
            v-if="$route.query.flag=='sign'&&isSuccess===true&&detail&&detail.info&&detail.info.signStatus == 2&&blockDetail.txId"
          >签署已完成</p>
          <p
            class="ft16"
            v-if="$route.query.flag=='sign'&&isSuccess===true&&detail&&detail.info&&detail.info.signStatus == 1&&blockDetail.txId"
          >签约成功</p>
          <p
            class="ft16"
            v-if="$route.query.flag=='sign'&&detail&&detail.info&&(!blockDetail.txId||isSuccess===false)"
          >签约失败</p>
          <div
            class="resetSign"
            v-if="$route.query.flag=='sign'&&detail&&detail.info&&(!blockDetail.txId||isSuccess===false)"
            @click="resetSign"
          >重新签约</div>
          <p
            class="ft16"
            v-if="$route.query.flag=='startSign'&&(isSuccess===true&&blockDetail.txId)"
          >签约创建成功</p>
          <p
            class="ft16"
            v-if="$route.query.flag=='startSign'&&(isSuccess===false||!blockDetail.txId)"
          >签约创建失败</p>
          <div
            class="resetSign"
            v-if="$route.query.flag=='startSign'&&(isSuccess===false||!blockDetail.txId)"
            @click="resetStart"
          >重新发起</div>
          <p v-if="detail&&isSuccess===true" class="ft12 blockLine">区块链记录ID:{{blockDetail.txId}}</p>
          <!-- <div
            class="setPre"
            v-if="detail&&detail.info&&detail.info.signStatus == 2&&blockDetail.txId"
            @click="toPreform"
          >设置履约任务</div> -->
        </div>
        <div class="performanceTurn">
          <h5>基本信息</h5>
          <div style="overflow:hidden" v-if="detail&&detail.info">
            <el-form class="first" label-width="110px">
              <el-form-item label="合同名称：">{{detail.info.name}}</el-form-item>
              <el-form-item label="发起签约时间：">{{detail.info.signStartTime}}</el-form-item>
              <el-form-item label="签署方式：">
                <span v-if="detail.info.orderType == 0">无序</span>
                <span v-if="detail.info.orderType == 1">顺序</span>
              </el-form-item>
              <el-form-item label="发起方：">{{detail&&detail.contractUser&&detail.contractUser.name}}</el-form-item>
            </el-form>
            <el-form label-width="110px">
              <el-form-item label="合同编号：">{{detail.info.code}}</el-form-item>
              <el-form-item label="签署完成时间：">{{detail.info.signFinishTime}}</el-form-item>
              <el-form-item label="签署截止日期：">{{detail.info.signDeadlineDate | formatData}}</el-form-item>
              <el-form-item label="合同有效期限：">
                <span
                  v-if="detail.info.startDate"
                >{{detail.info.startDate | formatData}}&nbsp;至&nbsp;{{detail.info&&detail.info.endDate | formatData}}</span>
              </el-form-item>
            </el-form>
            <el-form label-width="110px">
              <el-form-item label="证书签发机构：">司法联盟链legalXchain</el-form-item>
              <el-form-item label="签署平台：">广州公证处区块链赋强公证系统</el-form-item>
              <el-form-item label="时间戳：">国家授时中心北斗卫星授时</el-form-item>
              <el-form-item label="签署地点：">{{detail.info&&detail.info.signLocation}}</el-form-item>
            </el-form>
            <el-form class="el-last-form">
              <el-form-item label="签署方：">
                <span
                  class="moreNameSign"
                  v-for="(item,index) in detail.signatoryList"
                  :key="index"
                >{{item.name}}&nbsp;&nbsp;</span>
              </el-form-item>
            </el-form>
          </div>
          <!-- <p>
            <span>任务说明：</span>
            {{result.taskName}}
          </p>
          <img src="../../../assets/images/procedure/preservation_img.png" class="save">-->
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <ContractTypeDialog :visible="ShowContract.isShow"
      :appendToBody="true"
        :dialogTitle="ShowContract.title"
        @closeDialogfq="closeContract"
        :showClose="ShowContract.showClose"
        >
        <div slot="dialog-con" class="ContractType-con">
            <span>公证类型：</span>
            <el-radio-group v-model="ContractType">
              <!-- <el-radio-button label="0" v-if="detail.info.type==1 || detail.info.type==2 && getUserInfo.currentUserId == detail.contractUser.userId" class="ContractType-radio">合同公证</el-radio-button> -->
              <template v-if="detail && detail.info.type==2 && getUserInfo && getUserInfo.currentUserId != detail.contractUser.userId">
              <!-- <el-radio-button label="0" class="ContractType-radio">合同公证</el-radio-button> -->
                <el-radio-button label="1" class="ContractType-radio">赋强公证</el-radio-button>
              </template>
              <template v-if="detail && detail.info.type==4 && detail.info.signatoryRoleCode == 'DR'">
                <el-radio-button label="2" class="ContractType-radio">调解赋强公证</el-radio-button>
              </template>
              </el-radio-group>
        </div>
        <div slot="dialog-btn">
            <el-button type="primary" class="closeContract" @click="closeContract">取消</el-button>
            <el-button type="primary" class="subContract" @click="goContract">下一步</el-button>
        </div>
      </ContractTypeDialog>
    </template>
    <Dialog
      :visible="contractCancelShow"
      :dialogTitle="'撤销合同'"
      :width="'400px'"
      @closeDialog="closeDialog('contractCancelShow')"
    >
      <div class="signDetailDialogWithButton" slot="dialog">
        <div class="authDscp">
          <p>是否要撤销这份合同？</p>
          <p>撤销完成后，服务费将在1-3个工作日，</p>
          <p>退回到您的账户，请注意查收！</p>
        </div>
        <div class="authHandlerBox">
          <div
            class="button buttonActive cursorPointer"
            @click="closeDialog('contractCancelShow')"
          >取消</div>
          <div class="button cursorPointer" @click="revoke">确定</div>
        </div>
      </div>
    </Dialog>
    <div class="popUp">
      <Dialog
        :visible="dialogVisible"
        :dialogTitle="'申请律师服务'"
        v-on:closeDialog="closeDialog('dialogVisible')"
        :width="'600px'"
      >
        <div slot="dialog">
          <div class="solicitorBox">
            <solicitor
              @closeDialog="closeDialog('dialogVisible')"
              ref="multiples"
              @hintMessages="hintMessageFns"
              @closeHints="successMessageFns"
              @dialogVisible="dialogVisibleFn"
            ></solicitor>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="successFulBox"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('successFulBox')"
        :width="'400px'"
      >
        <div slot="dialog">
          <div class="successFulBox">操作成功</div>
        </div>
      </Dialog>
      <Dialog
        :visible="judiciaryBox"
        :dialogTitle="'申请司法鉴定'"
        v-on:closeDialog="closeDialog('judiciaryBox')"
        :width="'600px'"
      >
        <div slot="dialog" id="sfjd">
          <div class="authenticateBox">
            <p class="doingNum">
              您正在将
              <span style="color:#E88078;">1</span>个证据统一申请司法鉴定
            </p>
            <el-form
              :model="ruleFormjdc"
              :rules="rulesjdc"
              ref="ruleFormjdc"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="申请名称：" prop="comName">
                <el-input v-model="ruleFormjdc.comName" plcaeholder="输入要鉴定合同名称"></el-input>
              </el-form-item>
              <el-form-item label="包含证据文件：">1</el-form-item>
              <el-form-item label="机构名称：">海存科仪司法鉴定中心</el-form-item>
              <el-form-item label="机构地址：">北京市昌平区龙城北街金域国际中心B座402室</el-form-item>
              <el-form-item class="primaryBox">
                <el-button @click="cancalFn">取消</el-button>
                <el-button
                  type="primary"
                  :disabled="isSubmitIng"
                  @click="submitjdc('ruleFormjdc')"
                >确定</el-button>
              </el-form-item>
            </el-form>
            <p class="hint">申请成功后您可携带本人身份证或企业营业执照前往相应地址现场办理司法鉴定业务</p>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="applyNotar"
        :dialogTitle="'申请公证'"
        v-on:closeDialog="closeDialog('applyNotar')"
        :width="'600px'"
      >
        <div slot="dialog">
          <div class="applyNotar">
            <apply
              @closeDialog="closeDialog('applyNotar')"
              ref="multiples"
              @hintMessage="hintMessageFn"
              @applyNotar="applyNotarFn"
              @closeHints="successMessageFn"
            ></apply>
          </div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessage"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('hintMessage')"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">公证包名已存在</div>
        </div>
      </Dialog>
      <Dialog
        :visible="successBox"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('successBox')"
        :width="'400px'"
        @closeHint="successMessageFn"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">操作成功</div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessagess"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">该合同已经进行过司法鉴定</div>
        </div>
      </Dialog>
      <Dialog
        :visible="hintMessages"
        :dialogTitle="'消息提示'"
        v-on:closeDialog="closeDialog('hintMessages')"
        :width="'400px'"
        class="hintMessageBox"
      >
        <div slot="dialog">
          <div class="hintMessCon">选定合同已经申请过律师服务</div>
        </div>
      </Dialog>
      <Dialog
        :visible="applyNotars"
        :dialogTitle="'赋强公证'"
        v-on:closeDialog="closeDialog('applyNotars')"
        :width="'500px'"
      >
        <div slot="dialog">
          <div class="applyNotars">
            <div class="rlsbs wxapp-con">
              <p class="rlsb_desc">
                微信扫码在小程序完成赋强公证
              </p>
              <p class="rlsb_title">&nbsp;− 二维码5分钟内有效 −&nbsp;</p>
              <div class="erweima wxappCode">
                <!-- <vue-qr id="canvass" :text="codrUrl" :size="200"></vue-qr> -->
                <img :src="codrUrl"/>
              </div>
              <div class="erweima_errro wxapperror" v-show="error_erweima && status==1">
                <p class="error_title">二维码失效</p>
                <span class="update_erweima" @click="updateEr">点击刷新</span>
              </div>
              <div class="erweima_success wxappsuccess"  v-show="status==0">
                <img src="../../../assets/images/userHome/wxsmcg_icon.png"/>
                <p class="success_title">扫描成功</p>
                <p class="success_desc">请在手机端完成申请公证</p>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Dialog from "@common/Dialog.vue";
import PageSize from "@common/PageSize.vue";
import BaseApi from "@lib/baseApi.js";
import Breadcrumb from "../../../components/common/Breadcrumb.vue";
import apply from "../service/components/applyNotar.vue";
import solicitor from "../service/components/solicitorServices.vue";
import ContractTypeDialog from "@common/contractTypeDialog.vue";
import {mapState,mapGetters} from "vuex";
export default {
  components: {
    Breadcrumb,
    Dialog,
    apply,
    solicitor,
    ContractTypeDialog
  },
  data() {
    return {
      isSubmitIng: true,
      detail: null,
      contractCancelShow: false,
      revokeTaskId: "",
      isSuccess: 0,
      loading: false,
      blockDetail: {},
      count: 1,
      multipleSelection: [],
      id: "",
      hintMessagess: false,
      hintMessages: false,
      successBox: false,
      hintMessage: false,
      dialogVisible: false,
      successFulBox: false,
      judiciaryBox: false,
      applyNotar: false,
      revokeTaskId: "",
      contractUserIsFirst: false,
      ruleFormjdc: {
        comName: ""
      },
      rulesjdc: {
        comName: [
          { required: true, message: "请输入申请名称", trigger: "blur" }
        ]
      },
      ContractType:'1',
      ShowContract:{
        isShow:false,
        title:"选择公证类型",
        showClose:true
      },
      applyNotars:false,
      codrUrl:"",
      status:1,//二维码状态
      codeStatus:null,//认证状态
      error_num:false,
        //二维码扫描成功
      success_erweima:false,
      //二维码失效
      error_erweima:false,
      isshowTimeEnd:false,
      text:""
    };
  },
  computed:{
    ...mapState(['curState']),
    ...mapGetters(['getUserInfo','getCurInfo'])
  },
  created() {
    this.id = this.$route.query.id;
    this.loading = true;
    if (this.$route.query.flag == "startSign") {
      this.loadingStr = "签约创建完成，正在存证";
      let locationInfo = this.$store.getters.getLocation;
      BaseApi.createRpcToken(
        "/contract/start",
        {
          id: this.$route.query.id,
          signLocation: locationInfo && locationInfo.location,
          signLocationAttr: locationInfo && locationInfo.LocationAttr
        },
        "post"
      )
        .then(
          dataTemp => {
            if (dataTemp.datas && dataTemp.datas.success) {
              this.loopBlockDetail();
            } else {
              this.loading = false;
              this.isSuccess = false;
              this.init();
            }
          },
          () => {
            this.loading = false;
            this.isSuccess = false;
            this.init();
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    } else if (this.$route.query.flag == "sign") {
      this.loadingStr = "签署完成，正在存证";
      if (this.$route.query.isSuccess == "true") {
        this.loopBlockDetail(true);
      } else {
        this.isSuccess = false;
        this.init();
      }
    }
  },
  mounted() {
    var this_1 = this;
    // this_1.init();
  },
  filters: {
    formatData(value) {
      if (value) {
        return value.slice(0, 10);
      } else {
        return "";
      }
    }
  },
  methods: {
    closeDialog(flag) {
      this[flag] = false;
    },
    selectCre() {
      this.$router.push(
        `/personal/sign/SelectCertificate?id=${this.$route.query.id}`
      );
    },
    toSign() {
      let taskItem = this.getTaskId(this.detail.taskList, "SIGN", true);
      let isCanReject = 1;
      if (this.detail && this.detail.contractUser &&  this.detail.contractUser.userId == taskItem.userId) {
        isCanReject = 0;
      }
       // 判断是否已经支付过
          this.getContractInfo().then((resData)=> {
              this.$store.commit('showLoading', false);
              if (resData.datas.info.payStatus == 0) {
                //未支付，去支付
                this.$router.push({
                  path:"/personal/payment",
                  query:{ 
                    id: this.$route.query.id,
                    flag:'Sign',
                    taskId:taskItem.taskId,
                    isCanReject:isCanReject,
                    isHandwriting:false,
                    type:this.$route.query.type
                  }
                })
              } else {
                //已支付，去签署,1-普通合同；2-赋强合同
                if(this.$route.query.type==1){
                  this.$router.push(
                    `/personal/sign/index/signature?isHandwriting=false&id=${
                     this.$route.query.id
                    }&taskId=${taskItem.taskId}&isCanReject=${isCanReject}`
                  );
                }else if(this.$route.query.type==2){
                  this.$router.push(
                    `/personal/sign/signLoanIndex?isHandwriting=false&id=${
                      this.$route.query.id
                    }&taskId=${taskItem.taskId}&isCanReject=${isCanReject}`
                  );
                }else{  
                  this.$router.push(
                    `/personal/sign/signMediate?isHandwriting=false&id=${
                      this.$route.query.id
                    }&taskId=${taskItem.taskId}&isCanReject=${isCanReject}`
                  );
                }
              }
            },
            () => {
            })
      // this.$router.push(
      //   `/personal/sign/index/signature?isHandwriting=false&id=${
      //     this.$route.query.id
      //   }&taskId=${taskItem.taskId}&isCanReject=${isCanReject}`
      // );
    },
    getContractInfo() {
      return BaseApi.createRpcToken(
        "/contract/info",
        { id:  this.$route.query.id },
        "post"
      );
    },
    toPreform() {
      this.$router.push("/personal/performance/index");
    },
    selectContract() {
      this.$router.push(`/personal/sign/selectSign?id=${this.$route.query.id}`);
    },
    resetSign() {
      this.$router.push(
        `/personal/sign/index/signature?isHandwriting=false&id=${
          this.$route.query.id
        }&taskId=${this.$route.query.taskId}`
      );
    },
    resetStart() {
      this.$router.push(`/initiation/single?id=${this.$route.query.id}`);
    },

    getTaskId(data, flag, isAll) {
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].actionCode === flag) {
            if (isAll) {
              return data[i];
            } else {
              return data[i].taskId;
            }
          }
        }
      } else {
        return "";
      }
    },
    revoke() {
      this.loading = true;
      this.loadingStr = "请稍等，合同撤销中...";
      this.contractCancelShow = false;
      BaseApi.createRpcToken(
        "/contract/revoke",
        {
          id: this.$route.query.id,
          taskId: this.revokeTaskId
        },
        "post"
      )
        .then(data => {
          if (data.datas.success) {
            this.loading = false;
            this.$message.success("撤销成功");
            this.$router.push(
              `/personal/sign/detail?id=${this.$route.query.id}`
            );
          } else {
            this.loading = false;
            this.$message.error("撤销失败");
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    judgeRevoke() {
      this.revokeTaskId = this.getTaskId(this.detail.taskList, "REVOKE");
      if (this.revokeTaskId) {
        return true;
      } else {
        return false;
      }
    },
    showReject() {
      this.contractCancelShow = true;
    },
    loopBlockDetail(isSign) {
      if (this.count < 13 && !this.blockDetail.txId && this.$route.query.id) {
        if (isSign) {
          this.getBlockInfoForSign();
        } else {
          this.getBlockInfo();
        }
        setTimeout(() => {
          if (isSign) {
            this.loopBlockDetail(isSign);
          } else {
            this.loopBlockDetail();
          }
        }, 2000);
      }
    },
    //刷新二维码
    updateEr(){
      if(this.status==0){
        return;
      }else{
        this.error_erweima=false;
        this.addNotrats(this.detail.info)
      }
    },
    init() {
      BaseApi.createRpcToken("/contract/detail", {
        id: this.$route.query.id || "b70a942ada294030b8037ed556f57dd1"
      }).then(
        data => {
          this.loading = false;
          this.detail = data.datas.detail;
          if (this.getTaskId(this.detail.taskList, "SIGN")) {
            this.contractUserIsFirst = true;
          }
          if (this.detail && this.detail.info && this.detail.info.signatoryRoleCode == 'DR') {
            // 当前为借款人身份,签署成功后弹出小程序二维码
            this.addNotrats();
          }
        },
        () => {
          this.loading = false;
        }
      );
    },
    getBlockInfo(flag) {
      let loopCount = 0;
      BaseApi.createRpcToken("/contract/info", {
        id: this.$route.query.id
      })
        .then(
          data => {
            this.blockDetail = data.datas.info;
            if (this.blockDetail.txId) {
              this.isSuccess = true;
              this.init();
            } else if (!this.blockDetail.txId && this.count == 13) {
              this.isSuccess = false;
              this.init();
            }
          },
          () => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
      this.count++;
    },
    getBlockInfoForSign(flag) {
      let loopCount = 0;
      BaseApi.createRpcToken("/contract/queryTxId", {
        id: this.$route.query.id,
        sign: true
      })
        .then(
          data => {
            this.blockDetail = data.datas || {};
            if (this.blockDetail.txId) {
              this.isSuccess = true;
              this.init();
            } else if (!this.blockDetail.txId && this.count == 13) {
              this.isSuccess = false;
              this.init();
            }
          },
          () => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
      this.count++;
    },
    addFn(num) {
      if (num == "0") {
        this.dialogVisible = true;
        (this.multipleSelection = []), (this.id = this.$route.query.id);
        this.multipleSelection.push(this.id);
        this.$nextTick(function() {
          this.$refs.multiples.setData(this.multipleSelection);
        });
      } else if (num == "1") {
        this.judiciaryBox = true;
      } else {
        this.ShowContract.isShow = true;
        // this.applyNotar = true;
        // (this.multipleSelection = []), (this.id = this.$route.query.id);
        // this.multipleSelection.push(this.id);
        // this.$nextTick(function() {
        //   this.$refs.multiples.setData(this.multipleSelection);
        // });
      }
    },
    //关闭赋强公证弹框
    closeDialogs(){
      this.applyNotars=false;
    },
    closeContract(){
       this.ShowContract.isShow = false;
    },
    goContract(){
      if(this.ContractType == '0'){
        this.applyNotar=true;
        this.closeContract();
      }else{
        this.closeContract();
        //赋强公证
        this.addNotrats(this.detail.info)
      }
    },
    //实时获取二维码状态
    setTimerEr(contractId) {
      var timer=null;
      BaseApi.createRpcToken("/notaryApply/getWxUrlStatus",{contractId},"GET").then(data=>{
        if(data.code==200){
            clearTimeout(timer)
            this.status=data.datas.status;
            let self=this;
            if (self && !self._isDestroyed) {
              timer = setTimeout(() => {
                this.setTimerEr(contractId)
              }, 1000)  
            }
             if(this.isshowTimeEnd && data.datas.status!=0){
               clearTimeout(timer)
            }else
            //二维码失效
            if(this.error_erweima){
              clearTimeout(timer)
            }else if(data.datas.status==0){//扫码完成
               clearTimeout(timer)
            }
        }
      else {
          clearTimeout(timer) //清理定时任务
      }
      }, data => {
        
      })
      .catch(function (e) {
        errorLog(e);
      });
    },   
    // 赋强公证
    addNotrats(){
      BaseApi.createRpcToken("/notaryApply/checkCanFqNotaryApply", {
            contractId: this.detail.info.id,
            notaryId: 1,
          },
          "post"
      ).then(data => {
        let timer = null;
        const endTime = new Date().getTime() + 5 * 60 * 1000;
        timer = setInterval(() => {
          const start = new Date().getTime();
          if (start > endTime) {
            this.isshowTimeEnd = true;
            this.error_erweima = true;
            clearInterval(timer)
          } else {
            if (this.status == 0) {
              clearInterval(timer)
              this.isshowTimeEnd = false;
              this.error_erweima = false;
            } else {
              this.error_erweima = false;
            }
          }
        }, 1000)
        if (data.datas.code == 200) {
          this.codrUrl = "data:image/png;base64," + data.datas.wxUrlbase64;
          this.applyNotars = true;
          this.setTimerEr(this.detail.info.id);
        } else {
          this.$message.error(data.datas.message);
        }
      }).catch(function (e) {
        errorLog(e);
      });
    },
    hintMessageFns(data) {
      this.hintMessages = data;
    },
    successMessageFns(data) {
      this.successBox = data;
    },
    dialogVisibleFn(data) {
      this.dialogVisible = data;
    },
    submitjdc(formName) {
      this.isSubmitIng = true;
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sifa();
        } else {
          this.isSubmitIng = false;
          return false;
        }
      });
    },
    sifa() {
      var params = {
        expertisePackageName: this.ruleFormjdc.comName,
        expertiseCenterCode: "1",
        expertiseCenterAddress: "北京市昌平区龙城北街金域国际中心B座402室",
        contractCount: 1,
        contractIds: this.id
      };
      const loading = this.$loading({
        lock: true,
        text: "正在提交",
        target: "#sfjd"
      });
      BaseApi.createRpcToken("/Judiciary/addJudiciary", params, "post")
        .then(
          data => {
            if (data.datas == null) {
              this.successBox = true;
              setTimeout(() => {
                this.successBox = false;
                this.$router.replace({
                  path: "/personal/serviceHome",
                  query: {
                    flag: "second"
                  }
                });
                this.isSubmitIng = false;
              }, 1000);
            } else if ((data.datas.code = "7001")) {
              this.judiciaryBox = false;
              this.hintMessagess = true;
              setTimeout(() => {
                this.hintMessagess = false;
                this.judiciaryBox = true;
                this.isSubmitIng = false;
              }, 1000);
            } else {
              this.isSubmitIng = false;
            }
            loading.close();
          },
          data => {
            console.log(data);
            loading.close();
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    cancalFn() {
      this.judiciaryBox = false;
    },
    hintMessageFn(data) {
      this.hintMessage = data;
    },
    applyNotarFn(data) {
      console.log(data);
      this.applyNotar = data;
    },
    successMessageFn(data) {
      this.successBox = data;
    }
  },
  watch:{
    "curState"(data){
      this.$router.replace("/personal/sign/home");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.signDetailDialogWithButton {
  height: 200px;
  width: 400px;
  box-sizing: border-box;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0 20px;
  .authDscp {
    font-size: 14px;
    color: #646464;
    letter-spacing: 0;
    text-align: center;
    line-height: 20px;
    padding-top: 20px;
  }
  .withInput {
    width: 100%;
    text-align: left;
    .el-input__inner {
      width: 100%;
      height: 32px;
      line-height: 32px;
    }
  }
}

.signDetailMenu {
  float: right;
  margin: 20px 0;
  li {
    float: left;
    padding: 10px;
    font-size: 12px;
    line-height: 12px;
    border: 1px solid #D81212;
    margin-left: 10px;
    color: #D81212;
    cursor: pointer;
    img {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      padding-right: 7px;
    }
    .normal {
      display: inline-block;
    }
    .hover {
      display: none;
    }
    &:hover {
      background-color: #D81212;
      border: 1px solid #f0f0f0;
      color: white;
      .normal {
        display: none;
      }
      .hover {
        display: inline-block;
      }
    }
  }
}
.performanceBox {
  background: #eaedf1;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  .performanceMain {
    width: 100%;
    position: relative;
    height: 100%;
    display: table;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    .performanHead {
      width: 100%;
      height: 36px;
      padding: 8px 0;
      box-sizing: border-box;
      box-shadow: inset 0 -1px 0 0 rgba(230, 230, 230, 0.5);
      li {
        float: left;
      }
      li:nth-child(1) {
        display: block;
        width: 4px;
        height: 20px;
        background: #e88078;
        margin-right: 20px;
        border-radius: 4px;
      }
      li:nth-child(2) {
        // color:#787878;
        font-family: "PingFangSC-Medium";
      }
      li:last-child {
        color: #e88078;
      }
    }
    .performanceCon {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: calc(100% - 36px);
      .el-form {
        width: 400px;
        height: 540px;
        .el-form-item {
          width: 100%;
        }
        .el-form-item__label {
          line-height: 36px;
          font-size: 14px;
          color: #282828;
          width: 106px;
          padding: 0;
        }
        .el-form-item__label:before {
          content: "*";
          color: #f56c6c;
          margin-right: 4px;
          vertical-align: middle;
        }
        .el-form-item__content {
          line-height: 36px;
          float: left;
          .el-input__inner {
            width: 290px;
            padding-left: 10px;
            height: 36px;
            line-height: 36px;
            border-radius: 0;
          }
        }
        .el-range-separator {
          line-height: 28px;
        }
        .explainBox {
          height: 78px;
          .el-textarea__inner {
            width: 290px;
            height: 78px;
            resize: none;
          }
        }
        .el-form-item:nth-child(7),
        .el-form-item:nth-child(8) {
          .el-form-item__label:before {
            content: "";
          }
        }
        .el-button--primary {
          width: 120px;
          height: 36px;
          line-height: 36px;
          border: 1px solid #db4437;
          font-size: 14px;
          color: #db4437;
          padding: 0;
          background-color: #fff;
          margin-left: 106px;
        }
        .period {
          position: relative;
          .termination {
            position: absolute;
            right: -90px;
            top: 0;
          }
        }
      }
    }
    .performanceConFinsh {
      width: 100%;
      margin-top: 20px;
      height: calc(100% - 60px);
      padding-bottom: 20px;
      box-sizing: border-box;
      overflow: auto;
      margin-bottom: 20px;
      .performanceConHead {
        width: 100%;
        text-align: right;
        margin-bottom: 16px;
        span {
          display: inline-block;
          height: 32px;
          line-height: 32px;
          border: 1px solid #e88078;
          font-size: 14px;
          color: #e88078;
          text-align: center;
          margin-left: 10px;
          img {
            vertical-align: middle;
            margin-right: 4px;
          }
        }
        span:nth-child(1),
        span:nth-child(2) {
          width: 180px;
        }
        span:nth-child(3) {
          width: 100px;
        }
      }
      .performancebody {
        width: 100%;
        height: 329px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        border: 1px solid #e4e8eb;
        .setPre {
          background: #ffffff;
          border: 1px solid #e88078;
          border-radius: 5px;
          font-size: 14px;
          color: #e88078;
          text-align: center;
          line-height: 32px;
          width: 280px;
          cursor: pointer;
        }
        .resetSign {
          width: 100px;
          height: 32px;
          line-height: 32px;
          cursor: pointer;
          font-size: 12px;
          color: #db4437;
          text-align: center;
          border: 1px solid #db4437;
          margin-top: 16px;
        }
        .blockLine {
          height: 52px;
          line-height: 52px;
          padding: 0 20px;
          margin: 30px auto;
          background: #fafafa;
        }
        img {
          margin-bottom: 12px;
        }
        p {
          color: #505050;
        }
        p:last-child {
          margin-top: 30px;
          text-align: center;
          width: 563px;
          background: #f5f5f5;
          color: #969696;
        }
      }
      .performanceTurn {
        width: 100%;
        border: 1px solid #e4e8eb;
        border-radius: 0 0 3px 3px;
        height: 178px;
        position: relative;
        h5 {
          background: #f5f5f5;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          color: #323232;
          text-indent: 10px;
        }
        .el-form {
          float: left;
          width: calc(100% / 3);
          box-sizing: border-box;
          padding-top: 23px;
          .el-form-item {
            margin: 0;
            .el-form-item__label {
              // width: 110px;
              line-height: 23px;
              font-size: 12px;
              color: #787878;
            }
            .el-form-item__content {
              line-height: 23px;
              font-size: 12px;
              color: #969696;
            }
          }
        }
        .el-last-form {
          width: 100%;
          padding-top: 0;
          padding-left: 60px;
        }
        .first {
          padding-left: 10px;
        }
        p {
          text-indent: 10px;
          font-size: 12px;
          color: #969696;
          span {
            display: inline-block;
            width: 98px;
            font-size: 12px;
            color: #787878;
            text-align: right;
          }
        }
        .save {
          position: absolute;
          right: 226px;
          bottom: 25px;
          width: 129px;
          height: 106px;
        }
      }
    }
  }
  .authenticateBox {
    height: 319px;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    .doingNum,
    .hint {
      width: 100%;
      text-align: center;
      height: 32px;
      line-height: 32px;
      background-color: #f0f0f0;
      font-size: 12px;
      color: #969696;
    }
    .hint {
      width: 473px;
      margin-top: 20px;
    }
    .el-form {
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label {
          font-size: 12px;
          color: #919191;
          line-height: 30px;
          padding: 0;
        }
        .el-form-item__content {
          line-height: 30px;
          .el-input {
            .el-input__inner {
              width: 170px;
              height: 30px;
              line-height: 30px;
              border-radius: 0;
              border-color: #c8c8c8;
            }
          }
          .el-button {
            width: 100px;
            height: 32px;
            line-height: 32px;
            padding: 0;
            font-size: 12px;
            background-color: #fff;
            color: #646464;
            border: 1px solid #c8c8c8;
            border-radius: 0;
          }
          .el-button--primary {
            color: #db4437;
            border-color: #db4437;
            float: left;
          }
          .el-button:nth-child(2) {
            float: right;
          }
        }
      }
      .el-form-item:nth-child(1) {
        margin-top: 27px;
        margin-bottom: 11px;
      }
      .primaryBox {
        margin-top: 20px;
        .el-form-item__content {
          margin-left: 0 !important;
        }
        .el-button:first-child:hover {
          color: #db4437;
          border-color: #db4437;
        }
        .el-button:last-child:hover {
          color: #fff;
          border-color: #a5303d;
          background-color: #a5303d;
        }
      }
    }
  }
  .hintMessageBox {
    .hintMessCon {
      height: 200px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
.ContractBox{
    width: 520px;
    height: 262px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin-top: 15% !important;
    box-sizing: border-box;
    .el-dialog__header {
  display: block;
  padding: 0px;
  border-bottom: 1px solid #E9E9E9;
  padding: 20px;
}
    .ContractType-con{
      margin-top: 30px;
      padding:20px;
      .el-radio-button__inner{
        margin-left: 14px;
        width: 100px;
        height: 36px;
        background: #FFFFFF;
        box-shadow: none;
        border-radius: 18px;
        border: 1px solid #D9D9D9;
        outline: none;
      }
      .el-radio-button__inner:hover{
         color: #5B5B5B;
      }
       .el-radio-button__orig-radio:checked+.el-radio-button__inner{
            background: #FFF0F0;
              border: 1px solid #D81212;
              color: #D81212;
        }
    }
  }
.wxapp-con{
  height: 344px !important;
}
.wxappCode{
 width: 180px !important;
 height: 180px !important;
 margin-top:40px !important; 
}
.wxappCode_img{
  width:100% !important;
}
 .wxapperror {
    width: 180px !important;
    height: 180px !important;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 100px !important;
    left: 50%;
    margin-left: -90px !important;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.wxappsuccess{
    width: 180px!important;
    height: 180px!important;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 97px!important;
    left: 50%;
    margin-left: -90px!important;
    z-index: 99;
    text-align: center;
    padding-top: 35px;
    box-sizing: border-box;
}

.rlsbs{
  width: 100%;
  height: 300px;
  position: relative;
  .erweima_errro{
    width:160px;
    height:160px;
    background:rgba(255,255,255,0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left:-80px;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    box-sizing: border-box;
    .error_title{
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:600;
      color:rgba(50,50,50,1);
      margin-bottom: 12px;
    }
    .update_erweima{
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:#000;
      cursor: pointer;
    }
  }
  .erweima_success{
    width:160px;
    height:160px;
    background:rgba(255,255,255,0.78);
    position: absolute;
    top: 60px;
    left: 50%;
    margin-left:-80px;
    z-index: 99;
    text-align: center;
    padding-top: 35px;
    box-sizing: border-box;
    .success_desc{
      margin-bottom: 10px;
      margin-top: 3px;
      font-size: 13px;
    }
    .success_title{
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:600;
      color:rgba(50,50,50,1);
      margin-top: -4px;
    }
    .success_update_erweima{
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(77,175,247,1);
      cursor: pointer;
    }
    img{
      opacity: 1;
    }
  }
  .rlsb_title{
    color: #1890FF;
    margin: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span{
      display: inline-block;
      width: 8px;
      height: 1px;
      background: #1890FF;
      border:0;
    }
  }
  .erweima{
    width: 160px;
    margin: 0 auto;
    height: 160px;
    img{
      width: 100%;
    }
  }
  .rlsb_desc{
    width: 100%;
    text-align: center;
    height: 30px;
    line-height: 30px;
    margin-top: 20px;
  }
  .success_face{
    width: 183px;
    height: 40px;
    background: #D81212;
    border: 1px solid #D81212;
    font-size: 14px;
    font-weight: 500;
    color: #FFFFFF;
    display: block;
    margin: 0 auto;
  }
}
</style>
